<div class="modal-header">
  <div>
    <h4 class="modal-title" id="mondalAddCampaignTitle">Resumen</h4>
    <small class="subtitle">{{medio}}</small>
  </div>

  <div class="ms-auto d-flex align-items-center">
    <small class="me-2 subtitle">Última actualización: {{fecha_upd | date : "dd/MM/yyyy "}} por
      {{nombre_usuario}}</small>
    <button type="button" class="btn-close" mat-dialog-close></button>
  </div>
</div>


<mat-divider class="mt-2"></mat-divider>

<div *ngIf="!viewSucursales" class="d-flex justify-content-end mt-2 ms-3">
  <button mat-raised-button color="primary" (click)="verImagenes()">
    <mat-icon class="me-2">download</mat-icon>Descargar Archivos
  </button>
</div>

<mat-dialog-content *ngIf="!viewSucursales">
  <div class="modal-body">
    <div class="row g-3 card-first">
      <div class="col-md-6 ">
        <mat-card class="info-card2">
          <mat-card-content>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mt-2"><b>Medio</b></h6>
            </div>
            <mat-divider></mat-divider>
            <div class="mt-4 d-flex justify-content-between">
              <span>Medio</span><span><b>{{medio}}</b></span>
            </div>
            <div class="d-flex justify-content-between">
              <span>Alias</span><span><b>{{alias}}</b></span>
            </div>
            <div class="d-flex justify-content-between">
              <span>Elemento POP</span><span><b>{{elemento_pop}}</b></span>
            </div>
            <div class="d-flex justify-content-between">
              <span>Posición</span><span><b>{{posicion}}</b></span>
            </div>
            <div class="d-flex justify-content-between">
              <span>Descripción del medio</span>
              <span>
                <b [matTooltip]="descripcion.length > 50 ? descripcion : ''">
                  {{ descripcion.length > 50 ? (descripcion | slice:0:50) + '...' : descripcion }}
                </b>
              </span>
            </div>
            <div class="d-flex justify-content-between">
              <span>Comentarios</span>
              <span>
              <b [matTooltip]="(comentarios?.length ?? 0) > 50 ? (comentarios ?? '') : ''">
                {{ (comentarios?.length ?? 0) > 50 ? (comentarios | slice:0:50) + '...' : (comentarios ?? '') }}
              </b>
              </span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-md-6">
        <mat-card class="info-card">
          <mat-card-content>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0"><b>Sucursales</b></h6> 
                <button class="d-flex justify-content-end" matTooltip="Ver sucursales" matTooltipPosition="left" mat-icon-button (click)="openSucursales()">
                  <mat-icon color="accent">output</mat-icon>
                </button>
            </div> 
            <mat-divider></mat-divider>
            <div class="mt-4 d-flex justify-content-between">
              <span>Sucursales</span><span><b>{{sucursales}}</b></span>
            </div>
            <div class="d-flex justify-content-between">
              <span>Vendidos</span><span><b>{{vendidos}}</b></span>
            </div>

            <div class="mt-2">
              <div *ngFor="let d of dt_totales" class="d-flex justify-content-between">
                <span>{{d.nombre}}</span><span><b>{{d.inventario}}</b></span>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Tabla de promociones -->
    <div class="mt-4">
      <h6><b>Promociones seleccionadas: {{promSeleccionadas.length}}</b></h6>
      
      <div class="table-responsive text-nowrap">

      <table mat-table [dataSource]="promSeleccionadas" class="mat-elevation-z1 w-100">

        <ng-container *ngFor="let column of displayedColumns">
          <ng-container matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef class="do-jump-line-make-bonito" style="min-width: 170px; padding-right: 10px !important"> {{ column }} </th>
            <td mat-cell *matCellDef="let promo" style="min-width: 170px; padding-right: 20px;"> {{ promo[column] }} </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: allColumns;"></tr>
      </table>
      </div>

    </div>

  </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="viewSucursales">

  <div class="modal-body">
    <!-- Tabla de sucursales -->
    <div class="mt-2 ">
      <h6><b>Sucursales</b></h6>

      <mat-divider class="mt-2"></mat-divider>
      
      <div class="table-responsive text-nowrap card-suc">

      <table mat-table [dataSource]="sucursalesArr" class="mat-elevation-z1 w-100 ">

        <ng-container *ngFor="let column of colsSucursales">
          <ng-container matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef class="do-jump-line-make-bonito" style="min-width: 170px; padding-right: 10px !important"> {{ column }} </th>
            <td mat-cell *matCellDef="let suc" style="min-width: 170px; padding-right: 20px;"> {{ suc[column] }} </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colsSucursales"></tr>
        <tr mat-row *matRowDef="let row; columns: colsSucursales;"></tr>
      </table>
      </div>

    </div>

  </div>

</mat-dialog-content>

<div class="modal-footer">
    <button *ngIf="viewSucursales" mat-raised-button  class="me-2" (click)="openSucursales()">Regresar</button>
    <button mat-raised-button color="primary" mat-dialog-close>Cerrar</button>
</div>